__turbopack_context__.v({
  "container": "bCw9Xq_container",
  "mainSkeletonStyles": "bCw9Xq_mainSkeletonStyles",
  "skeletonStyles": "bCw9Xq_skeletonStyles",
  "textStyles": "bCw9Xq_textStyles",
});
